module.exports = __webpack_public_path__ + "img/home.2a5acf38.png";